import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { BasePageTitle } from "altus-ui-components";

import {
  getMarkersFromState,
  getQualificationsFromState,
  getEmployeeGroupsFromState,
} from "features/planner/planner.selectors";

import TextField from "app/components/form/TextField";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import { SUB_CONTRACTOR_FORM } from "features/planner/planner.constants";
import Marker from "features/planner/components/Card/EmployeeCard/Marker";
import DatePickerField from "app/components/form/DatePickerField";

class SubContractorContractForm extends PureComponent {
  render() {
    const {
      classes,
      markers,
      qualifications,
      employeeGroups,
      availableMarkers,
    } = this.props;

    return (
      <Grid
        item
        xs={6}
        lg={4}
        container
        direction="column"
        style={{
          display: "block",
        }}
      >
        <Grid item>
          <BasePageTitle title="Contract" />
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={6}>
            <Field
              component={DatePickerField}
              name={SUB_CONTRACTOR_FORM.HIRED_FROM}
              DatePickerProps={{
                margin: "normal",
                label: "Hired From",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              component={DatePickerField}
              name={SUB_CONTRACTOR_FORM.HIRED_TO}
              DatePickerProps={{
                margin: "normal",
                label: "Hired To",
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Field
            label="Shift"
            defaultValue="-"
            component={ReadOnlyField}
            name={SUB_CONTRACTOR_FORM.SHIFT}
          />
        </Grid>
        <Grid item xs>
          <Field
            select
            label="Qualification"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.QUALIFICATION}
            SelectProps={{
              classes: {
                select: classes.select,
              },
            }}
          >
            <MenuItem value={null}>None</MenuItem>
            {qualifications.map(qualification => (
              <MenuItem
                key={qualification.get("id")}
                value={qualification.get("id")}
              >
                <Grid container alignItems="center">
                  <Grid
                    item
                    className={classes.listItemIcon}
                    style={{ background: qualification.get("backColor") }}
                  ></Grid>
                  <Grid item>{qualification.get("name")}</Grid>
                </Grid>
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid item xs>
          <Field
            select
            component={TextField}
            label="Employee Group"
            name={SUB_CONTRACTOR_FORM.EMPLOYEE_GROUP}
          >
            <MenuItem value={null} key={-1} />
            {employeeGroups.map(employeeGroup => (
              <MenuItem
                key={employeeGroup.get("id")}
                value={employeeGroup.get("id")}
              >
                {employeeGroup.get("name")}
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid container>
          {markers
            .keySeq()
            .toJS()
            .map(index => {
              return (
                <Grid
                  item
                  xs={6}
                  key={index}
                  className={classes.markerFormItem}
                >
                  <Field
                    select
                    component={TextField}
                    label={`Marker ${index}`}
                    name={`${SUB_CONTRACTOR_FORM.MARKERS}.${index.toString()}`}
                    SelectProps={{
                      classes: {
                        select: classes.select,
                      },
                    }}
                  >
                    <MenuItem value={null} key={-1} />
                    {availableMarkers.map(marker => (
                      <MenuItem
                        key={marker.get("id")}
                        value={marker.get("id").toString()}
                      >
                        <Grid container alignItems="center">
                          <Grid item className={classes.listItemIcon}>
                            <Marker marker={marker} />
                          </Grid>
                          <Grid item>{marker.get("name")}</Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  select: {
    display: "flex",
    alignItems: "center",
  },
  markerFormItem: {
    "&:nth-child(even)": {
      paddingLeft: theme.spacing(1),
    },
    "&:nth-child(odd)": {
      paddingRight: theme.spacing(1),
    },
  },
  listItemIcon: {
    width: "1rem",
    height: "1rem",
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
});

export default compose(
  connect(state => ({
    availableMarkers: getMarkersFromState(state),
    qualifications: getQualificationsFromState(state),
    employeeGroups: getEmployeeGroupsFromState(state),
  })),
  withStyles(styles),
)(SubContractorContractForm);
